import React from 'react';

function Icon() {
  return (
    <svg width="9" height="16" fill="none" viewBox="0 0 9 16">
      <path fill="#4783FF" d="M8.916 1.352L7.564 0 0 7.564l7.564 7.564 1.352-1.353-6.211-6.211 6.211-6.212z"></path>
    </svg>
  );
}

export default Icon;
